module.exports = __webpack_public_path__ + "img/MEDIA069.5346f8a9.jpg";